import { User } from "oidc-client";

interface AuthState {
  accessToken?: string;
  isAuthenticated: boolean;
  isLoading: boolean;
  error?: Error;
  user?: User;
}

export const defaultAuthState: AuthState = {
  isAuthenticated: false,
  isLoading: true
};

export default AuthState;
